import { render, staticRenderFns } from "./DetailsTitle.vue?vue&type=template&id=67289629&scoped=true"
import script from "./DetailsTitle.vue?vue&type=script&lang=js"
export * from "./DetailsTitle.vue?vue&type=script&lang=js"
import style0 from "./DetailsTitle.vue?vue&type=style&index=0&id=67289629&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67289629",
  null
  
)

export default component.exports